import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import ReactDOM from "react-dom";
import "./index.less";
import { useOpenRedpack } from "@/store/redpack";
import { useGlobalOpenRedPack } from "@/store/commonStore";
import CountdownSeconds from "../compoments/countdownSeconds";
import { debounce } from "@/Core/utils";
import NiceModal from "@ebay/nice-modal-react";
import CommonPopup from "@/pages/commonPopup";
import { AmountDivisorConversion } from "@/Core/utils/currencyDealCenter";

import ballon_1 from "./balloon_blue_.webp";
import ballon_2 from "./balloon_green.webp";
import ballon_3 from "./balloon_orange.webp";
import ballon_4 from "./balloon_red.webp";
// Christmas theme items
import christmasGift from "./christmas/liwu.png";
import christmasSock from "./christmas/wazi.png";
import christmasBall from "./christmas/qiu.png";
import christmasBox from "./christmas/baoxiang.png";
import useScreenDesign from "@/Core/utils/hooks/useScreenDesign";
import RedpackSettlement from "../redpackSettlement/RedpackSettlement";
import {
  createRedpackRewardHint,
  RedpackRewardHint,
} from "./redpackRewardHint";

const RedpackRainPage = () => {
  const [data, setOpen] = useGlobalOpenRedPack();

  const { trigger } = useOpenRedpack();
  const isMobile = useScreenDesign();
  const packs = useRef(
    new Array(isMobile ? 10 : 25).fill(1, 0, isMobile ? 10 : 25)
  );
  const booms = useRef([]);
  const [, setUpdate] = useState({});
  const packRefs = useRef([]);
  const [rewardHints, setRewardHints] = useState<RedpackRewardHint[]>([]);
  const rewardHintIdRef = useRef(0);

  const totalRef = useRef(0);

  const currencyTypeRef = useRef("");

  const debounceTrigger = useCallback(
    debounce((position: { left: number; bottom: number }) => {
      trigger().then((res: any) => {
        if (res.rewardcnt) {
          currencyTypeRef.current = res.currencyType;
          //中奖了
          totalRef.current += AmountDivisorConversion(res.rewardcnt, {
            currencyType: res.currencyType,
          });
          const hint = createRedpackRewardHint({
            id: ++rewardHintIdRef.current,
            rewardcnt: res.rewardcnt,
            currencyType: res.currencyType,
            left: position.left,
            bottom: position.bottom,
            convertRewardAmount: (rewardcnt, currencyType) =>
              AmountDivisorConversion(rewardcnt, {
                currencyType: currencyType as any,
              }),
          });

          if (hint) {
            setRewardHints((items) => [...items, hint]);
            window.setTimeout(() => {
              setRewardHints((items) =>
                items.filter((item) => item.id !== hint.id)
              );
            }, 900);
          }
        }
      });
    }),
    []
  );

  const debounceClick = (index) => {
    const target = packRefs.current[index];
    if (!target) return;

    const rect = target.getBoundingClientRect();
    if (
      target.className.includes("pack") &&
      !target.className.includes("pack-new")
    ) {
      target.className = target.className.replace("pack", "pack-new");
    }

    const clickPosition = {
      left: rect.left + rect.width / 2,
      bottom: window.innerHeight - rect.bottom + rect.height * 0.48,
    };

    booms.current.push({
      left: rect.left,
      bottom: window.innerHeight - rect.bottom,
      boomClass: target.boomClass,
    });
    setUpdate({});
    setTimeout(() => {
      booms.current.shift();
      if (target) {
        target.className = target.className.replace("pack-new", "pack");
      }
      setUpdate({});
    }, 500);
    debounceTrigger(clickPosition);
  };

  /**点击红包 */
  const onClickPack = useCallback((index) => {
    debounceClick(index);
  }, []);

  const PackContatiner = useMemo(() => {
    // Christmas theme items
    const christmasItems = [
      christmasGift,
      christmasSock,
      christmasBall,
      christmasBox,
    ];
    const boomClass = ["boom-gift", "boom-sock", "boom-ball", "boom-box"];

    return (
      <div className="pack-contatiner">
        {packs.current.map((v, index) => {
          const left = Math.random() * (window.innerWidth - 120) + "px";
          const delay = 3 + Math.random() * 2 + index * 0.3;
          const pathIndex = Math.floor(Math.random() * 4);
          return (
            <div
              key={index}
              className="pack christmas-pack"
              onClick={() => onClickPack(index)}
              style={{
                left: left,
                animation: `rain ${delay}s linear infinite`,
              }}
              ref={(element) => {
                packRefs.current[index] = element;
                if (packRefs.current[index] && boomClass) {
                  packRefs.current[index].boomClass = boomClass[pathIndex];
                }
              }}
            >
              <img
                src={christmasItems[pathIndex]}
                className="christmas-item"
                draggable={false}
              ></img>
            </div>
          );
        })}
      </div>
    );
  }, []);

  //倒计时结束
  const onCountdownFinish = useCallback(() => {
    setOpen(null);
    document.body.classList.remove("redpack-open");
    NiceModal.show(RedpackSettlement, {
      amount: totalRef.current,
      currency: currencyTypeRef.current,
    });
  }, []);

  useEffect(() => {
    if (data) {
      document.body.classList.add("redpack-open");
    } else {
      document.body.classList.remove("redpack-open");
    }
  }, [data]);

  return ReactDOM.createPortal(
    <div className="redpack-rain-page">
      {PackContatiner}
      <div className="pack-boom">
        {booms.current.map((v, index) => {
          return (
            <div
              className={`boom ${v.boomClass}`}
              key={`${index}-${Date.now()}`}
              style={{
                left: v.left,
                bottom: v.bottom,
              }}
              onAnimationEnd={(e) => {
                e.currentTarget.style.display = "none";
              }}
            ></div>
          );
        })}
      </div>
      <div className="reward-hints">
        {rewardHints.map((hint) => (
          <div
            className="reward-hint"
            key={hint.id}
            style={{
              left: hint.left,
              bottom: hint.bottom,
            }}
          >
            {hint.text}
          </div>
        ))}
      </div>
      <CountdownSeconds
        seconds={data?.redRainTime}
        onCountdownFinish={onCountdownFinish}
      />
    </div>,
    document.body
  );
};

export default RedpackRainPage;
